import type { ReactNode } from 'react';
import { DataTablePagination } from '../../../components/common/DataTable';
import { OUTREACH_MAX_PAGE_SIZE, PAGE_SIZE_OPTIONS } from '../../useCampaignPageSizeParam';
import { CrmCardError } from './CrmCard';
import { crmLoadErrorCopy } from './crmLoadError';
import type { CrmListPaging } from './useCrmListPaging';

/** What the lists call their content in an error line. */
export const CRM_LIST_SUBJECT = 'creators';

interface CrmListFrameProps {
  /** The list query's error, null while it is fine. */
  error: unknown;
  total: number;
  paging: CrmListPaging;
  children: ReactNode;
}

/** The card a CRM list sits in, with the shared paginator under it; a failed read replaces the table with its error line. */
export function CrmListFrame({ error, total, paging, children }: CrmListFrameProps) {
  return (
    <div className="overflow-hidden rounded-xl border border-border bg-card">
      <ListBody error={error}>{children}</ListBody>
      <DataTablePagination
        pagination={{
          page: paging.page,
          pageSize: paging.pageSize,
          total,
          onPageChange: paging.setPage,
          pageSizeOptions: PAGE_SIZE_OPTIONS,
          offerAllSizes: true,
          onPageSizeChange: paging.setPageSize,
          noun: 'creators',
          maxPageSize: OUTREACH_MAX_PAGE_SIZE,
        }}
      />
    </div>
  );
}

/** A failed read replaces the table with its error line. */
function ListBody({ error, children }: { error: unknown; children: ReactNode }) {
  if (error) return <CrmCardError>{crmLoadErrorCopy(CRM_LIST_SUBJECT, error)}</CrmCardError>;
  return <>{children}</>;
}
